import { useRouter } from "next/router";

import { ROUTES } from "@shared/routing/routes";

export const useIsOfferSummaryPage = () => {
  const router = useRouter();

  return router.pathname === ROUTES.OFFER_SUMMARY;
};
